import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store'
import App from './containers/App'
import IntlProvider from './containers/IntlProvider'
import { addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import { LocaleProvider, message } from 'antd'
import es_ES from 'antd/lib/locale-provider/es_ES';

message.config({ maxCount: 1 })

addLocaleData([...en, ...es])

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <LocaleProvider locale={es_ES}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </LocaleProvider>
    </IntlProvider>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js